import { useMemo } from "react";
import { ConnectProto } from "@racoon/api";

const uniq = <T>(arr: T[], key: (v: T) => string | number) => {
  const m = new Map<string | number, T>();
  arr.forEach((v) => m.set(key(v), v));
  return Array.from(m.values());
};

export const useRouteOptions = (routes?: ConnectProto.Route[]) => {
  return useMemo(() => {
    const drivers: { id: string; name: string }[] = [];
    const objects: { id: string; name: string }[] = [];
    const customers: { id: string; name: string }[] = [];

    (routes ?? []).forEach((r) => {
      const td = r.driverOnShift?.driver;
      if (td?.id) {
        const name = [td.firstName, td.lastName].filter(Boolean).join(" ").trim();
        if (name) {
          drivers.push({
            id: String(td.id),
            name: name,
          });
        }
      }

      (r.jobs ?? []).forEach((j) => {
        const d = j.driverOnShift?.driver;
        if (d?.id) {
          const name = [d.firstName, d.lastName].filter(Boolean).join(" ").trim();
          if (name) {
            drivers.push({
              id: String(d.id),
              name: name,
            });
          }
        }

        const obj = j.pickupLocation;
        if (obj?.id) {
          const name = obj.name?.trim();
          if (name) {
            objects.push({ id: String(obj.id), name: name });
          }
        }

        const org = j.serviceReceiver;
        if (org?.id) {
          const name = org.name?.trim();
          if (name) {
            customers.push({ id: String(org.id), name: name });
          }
        }
      });
    });

    return {
      drivers: uniq(drivers, (x) => x.id),
      objects: uniq(objects, (x) => x.id),
      customers: uniq(customers, (x) => x.id),
    };
  }, [routes]);
};

